<template>
  <div class="community zindex11">
    <div class="left fadeInLeft">
      <div class="big-title"><img src="https://static.worldaic.com.cn/2024/web/static/images/c.png" alt="">ommunity 资讯</div>
      <ul>
        <li v-for="(item, index) in data" :key="index" @click="leftClick(item, index)">
          <div class="title ellipsis2">{{ item['journalismTitle' + En] }}</div>
          <div class="text ellipsis3 vtext1" v-html="item['journalismShort' + En]"></div>
          <div class="releaseTime">{{ item.releaseTime }}</div>
        </li>
      </ul>
      <div class="btn pc">
        <!-- <span @click="$router.push('/zixun')">{{ $t('learnMore') }}</span> -->
        <img @click="$router.push('/zixun')" v-if="En" class="pub-learn" src="https://static.worldaic.com.cn/2024/web/static/images/learnEn.png" alt="">
        <img @click="$router.push('/zixun')" v-else class="pub-learn" src="https://static.worldaic.com.cn/2024/web/static/images/learn.png" alt="">
      </div>
    </div>
    <div class="right fadeInRight" v-if="allList && allList.length">
      <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper" id="swiper">
        <swiper-slide v-for="(item, index) in allList" :key="index">
          <ul class="item">
            <li v-for="(ite, ind) in item" :key="ind" @click="rightClick(ite, ind, index)">
              <img :src="ite.journalismCoverPhone" alt="">
              <div class="text">
                <div class="title ellipsis2">{{ ite['journalismTitle' + En] }}</div>
                <div class="box">
                  <p class="ellipsis2 vtext2" v-html="ite['journalismShort' + En]"></p>
                  <div class="btn">
                    <span>{{ $t('learnMore') }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </swiper-slide>
      </swiper>
      <div class="swiper-btns">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/prev.png" alt="" @click="prevTo('prev')" class="prev btn-img">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/next.png" alt="" @click="prevTo('next')" class="next btn-img">
      </div>
    </div>
    <div class="btn-wap wap" @click="$router.push('/zixun')">
      <!-- <span>{{ $t('learnMore') }}</span> -->
      <img v-if="En" class="pub-learn" src="https://static.worldaic.com.cn/2024/web/static/images/learnEn.png" alt="">
      <img v-else class="pub-learn" src="https://static.worldaic.com.cn/2024/web/static/images/learn.png" alt="">
    </div>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  name: 'community',
  data() {
    return {
      swiperOptions: {
        // autoplay : {
        //   delay:3000
        // },
      },
      data: [],
      list: [],
      allList: [],
      typeList: [],
      newsTit1: {},
      newsTit2: {},
    }
  },
  async created() {
    await protal.getZdType("journalism_type").then((res) => {
      if (res && res.data && res.data.length) {
        this.typeList = res.data;
        this.newsTit1 = this.typeList[0];
        this.newsTit2 = this.typeList[1];
      }
    });
    this.getData1()
    this.getData2()
  },
  watch: {
    async En() {
      await protal.getZdType("journalism_type").then((res) => {
        if (res && res.data && res.data.length) {
          this.typeList = res.data;
          this.newsTit1 = this.typeList[0];
          this.newsTit2 = this.typeList[1];
        }
      });
      this.getData1()
      this.getData2()
    }
  },
  methods: {
    async leftClick(item, index) {
      // console.log(item.dataTagRes, '标签')
      // let arr = item.dataTagRes || []
      // arr = arr.map(x => x.dataTag)
      // let industryFirstCate_var = this.labels.filter(x => arr.includes(x.uuid)).map(x => x.lableDesc).join('|')
      this.$jsAPI('track','homeClick',
          {
            'floor_var': 'Community资讯',
            'position_var': `1-${ index + 1 }`,
            'flowName_var': item.journalismTitle,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryFirstCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industrySecCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': `文章`,
          }
      );
      gio('track','homeClick',
          {
            'floor_var': 'Community资讯',
            'position_var': `1-${ index + 1 }`,
            'flowName_var': item.journalismTitle,
            'industryCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industryFirstCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': `文章`,
          }
      );
      
      this.$router.push({ name: 'fabu', query: { uuid: item.uuid } })
    },
    async rightClick(item, ind, index) {
      // console.log(item.dataTagRes, '标签')
      // let arr = item.dataTagRes || []
      // arr = arr.map(x => x.dataTag)
      // let industryFirstCate_var = this.labels.filter(x => arr.includes(x.uuid)).map(x => x.lableDesc).join('|')
      this.$jsAPI('track','homeClick',
          {
            'floor_var': 'Community资讯',
            'position_var': `2-${ index * 3 + ind + 1 }`,
            'flowName_var': item.journalismTitle,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryFirstCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industrySecCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': `卡片`,
          }
      );
      gio('track','homeClick',
          {
            'floor_var': 'Community资讯',
            'position_var': `2-${ index * 3 + ind + 1 }`,
            'flowName_var': item.journalismTitle,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industryFirstCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': `卡片`,
          }
      );
      
      this.$router.push({ name: 'fabu', query: { uuid: item.uuid } })
    },
    prevTo(str) {
      if (str === 'prev') {
        this.$refs.mySwiper.swiper.slidePrev()
      } else {
        this.$refs.mySwiper.swiper.slideNext()
      }
    },
    getData1() {
      let newsObj1 = {
        journalismType: this.newsTit1.uuid,
        pageNum: this.pageNum1,
        pageSize: 2,
        isWonderfulMoment: 1,
        viewTypes: this.En ? [2] : [1],
        isRecommend: 0
      };
      protal.queryOfficialFrontJournalismList(newsObj1).then((res) => {
        if (res && res.data && res.data.length) {
          this.data = res.data || []
          this.setSuccessNum()
        }
      });
    },
    getData2() {
      let newsObj2 = {
        journalismType: this.newsTit2.uuid,
        pageNum: this.pageNum2,
        pageSize: 9999,
        isWonderfulMoment: 1,
        viewTypes: this.En ? [2] : [1],
        isRecommend: 0
      };
      protal.queryOfficialFrontJournalismList(newsObj2).then((res) => {
        if (res && res.data && res.data.length) {
          this.list = res.data;
          this.list.map((x, i) => {
            if (this.isPc) {
              if (i % 3) {
                this.allList[this.allList.length - 1].push(x)
              } else {
                this.allList.push([x])
              }
              return
            }

            if (i % 2) {
              this.allList[this.allList.length - 1].push(x)
            } else {
              this.allList.push([x])
            }
          })
        }
      });
    },
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .community {
    width: 100%;
    height: 9rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/community-bg.jpg");
    background-size: cover;
    padding: 0 1.96rem 0 1.1rem;
    display: flex;
    justify-content: space-between;
    text-align: left;

    .left {
      flex: 0 0 6rem;
      padding-top: 1rem;

      ul {
        margin-top: .96rem;

        li {
          margin-bottom: .58rem;
          cursor: pointer;

          .title {
            font-family: sybold;
            font-size: .32rem;
            color: #3E3A39;
            line-height: .4rem;
            margin-bottom: .18rem;
          }

          .text {
            font-size: .2rem;
            color: #727171;
            line-height: 1.6;
            margin-bottom: .18rem;
          }

          .releaseTime {
            font-size: .16rem;
            color: #999;
            line-height: 1;
          }
        }
      }

      .btn {
        font-size: .18rem;
        font-weight: 400;
        color: #595757;
        line-height: 1;
        margin-top: .8rem;
        span {
          cursor: pointer;
        }
      }
    }

    .right {
      position: relative;
      width: 8.34rem;
      padding-top: 1.84rem;

      .my-swiper {
        width: 100%;

        ul {
          width: 100%;
          display: block;
          white-space: nowrap;
          
          li {
            display: inline-block;
            vertical-align: top;
            width: 2.7rem;
            border-radius: .16rem;
            background: #F6F7F7;
            overflow: hidden;
            margin-right: .12rem;
            white-space: normal;
            cursor: pointer;
          
            img {
              display: block;
              width: 100%;
              height: 4.05rem;
              border-radius: .16rem;
            }

            .text {
              padding: .1rem .16rem .2rem;

              .title {
                font-family: sybold;
                font-size: .22rem;
                font-weight: 500;
                color: #3E3A39;
                line-height: .32rem;
                height: .64rem;
              }

              p {
                font-size: .18rem;
                font-weight: 400;
                color: #727171;
                line-height: .28rem;
                margin-top: .05rem;
                height: .56rem;
              }

              .btn {
                text-align: right;
                padding-top: .04rem;
                height: .3rem;
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;

                span {
                  font-size: .14rem;
                  font-weight: 400;
                  color: #595757;
                  line-height: .26rem;
                  cursor: pointer;
                }
              }

              .box {
                height: 0;
                transition: 1s;
                overflow: hidden;
              }
            }

            &:hover .text {
              .box {
                height: .9rem;
              }
            }
          }
        }
      }

      .btn-img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        width: .5rem;
        height: auto;

        &.prev {
          left: -0.86rem;
        }

        &.next {
          right: -0.86rem;
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .community {
    position: relative;
    width: 100%;
    padding: .8rem .4rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/community-bg-wap.jpg");
    background-size: 100% 100%;
    text-align: left;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(-135deg, #2FA0F9 0%, rgba(248, 248, 248, 0) 100%);
      opacity: 0.2;
      z-index: -1;
    }

    .left {

      ul {
        margin-top: .86rem;

        li {
          margin-bottom: .48rem;

          .title {
            font-size: .32rem;
            color: #3E3A39;
            line-height: 1.5;
            font-weight: bold;
            margin-bottom: .2rem;
          }

          .text {
            font-size: .22rem;
            color: #727171;
            line-height: .34rem;
          }

          .releaseTime {
            font-size: .2rem;
            color: #999;
            line-height: 1;
          }
        }
      }

      .btn {
        font-size: .16rem;
        font-weight: 400;
        color: #595757;
        line-height: .24rem;
        margin-top: 1.1rem;
        span {
          cursor: pointer;
        }
      }
    }

    .right {
      position: relative;
      width: 100%;

      .my-swiper {
        width: 100%;

        ul {
          width: 100%;
          display: block;
          white-space: nowrap;
          
          li {
            display: inline-block;
            vertical-align: top;
            width: 3.26rem;
            border-radius: .16rem;
            background: #F6F7F7;
            overflow: hidden;
            margin-right: .18rem;
            white-space: normal;
          
            img {
              display: block;
              width: 100%;
              height: 4.89rem;
              border-radius: .16rem;
            }

            .text {
              padding: .16rem .2rem .24rem;

              .title {
                font-size: .24rem;
                font-weight: 500;
                color: #3E3A39;
                line-height: .32rem;
                height: .6rem;
                font-weight: bold;
              }

              p {
                font-size: .2rem;
                font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                font-weight: 400;
                color: #727171;
                line-height: 1.4;
                margin-top: .16rem;
              }

              .btn {
                display: none;
                text-align: right;
                margin-top: .32rem;

                span {
                  font-size: .2rem;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 400;
                  color: #595757;
                  line-height: 1;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }

      .swiper-btns {
        display: none;
        justify-content: center;
        margin-top: .28rem;
        display: none;
      }

      .btn-img {
        width: .36rem;
        margin: 0 .32rem;
      }
    }

    .btn-wap {
      margin-top: .52rem;
      font-size: .22rem;
      color: #595757;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/community.vue